import $ from 'jquery';

$(document).ready(function() {
	$(document).on('keyup', '.js-subscription-input', function() {
		let subscriptionButton = $(this).parents('.js-subscription-form').find('.js-subscription-button');
		if ($(this).val() !== "" && $(this).val() !== undefined) {
			subscriptionButton.prop('disabled', false);
		} else {
			subscriptionButton.prop('disabled', true);
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/main/subscription.js